import { DataContext } from '../../my-meet/models/data-context.model';

export class FollowModalDataModel {
  dataContext: DataContext;
  openOnPageLoad: boolean = false;

  constructor(dataContext: DataContext) {
    this.dataContext = dataContext;
  }
}
